import bem from 'utils/bem';

export const block = bem('full-episode-captions-upsell-modal');
